import { createReducer } from 'lib/utilities';
import getWeekRange from '../lib/getWeekRange';

const initialState = () => ({
  displaySidebar: true,
  calendarView: 'weekly',
  fetchingTodos: false,
  dateRange: {
    ...getWeekRange(),
    selectedDate: new Date(),
  },
});

export default createReducer(initialState(), {
  todosSetSidebar: (state, payload) => ({ ...state, displaySidebar: payload }),
  todosResetState: (state) => ({ ...initialState() }),
  todosSetDateRange: (state, payload) => ({ ...state, dateRange: payload }),
  todosResetDateRange: (state, payload) => ({ ...state, dateRange: initialState().dateRange }),
  todosSetFetchingTodos: (state, payload) => ({ ...state, fetchingTodos: payload }),
});
